export default __webpack_public_path__ + "img/team-1-800x800.fa5a7ac2.jpg";